import CategoriesData from "../CategoriesData/CategoriesData";

export default function Singing() {
  return (
    <>
      <div className="p-4">
        <h1>Singing</h1>
        <hr />
        <CategoriesData catType={"Singing"} />
      </div>
    </>
  );
}
